function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect } from 'react';
import { SubMenu } from '../../../models/menu';
import { useSingleton } from '@bydesign-ui/hooks';
import { SubMenuContext } from '../context/SubMenu';
import { useMenu } from '../hooks/useMenu';
import { useParentSubMenu } from '../hooks/useParentSubMenu';
export function RcSubMenu(props) {
  var children = props.children,
      insId = props.insId,
      extra = _objectWithoutProperties(props, ["children", "insId"]);

  var menu = useMenu();
  var parent = useParentSubMenu();
  var subMenu = useSingleton(function () {
    return new SubMenu(menu, extra, parent, insId);
  });
  useEffect(function () {
    return function () {
      subMenu.dispose();
    };
  }, []);
  return React.createElement(SubMenuContext.Provider, {
    value: subMenu
  }, children);
}